import { render, staticRenderFns } from "./ChangePasswordSettings.vue?vue&type=template&id=60b1109c&scoped=true&"
import script from "./ChangePasswordSettings.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordSettings.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordSettings.vue?vue&type=style&index=0&id=60b1109c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b1109c",
  null
  
)

export default component.exports